module.exports = __webpack_public_path__ + "img/bg.e671d914.svg";